import React from 'react'
import { Box } from '@mui/joy';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import ActiveJob from '../../blocks/customer/ActiveJob';
import Footer from '../../component/footer/Footer';


const ActiveJobPage = () => {
    return (
        <>
           <Box
                   sx={{
                     width:'100%',
                     padding: '0',
                     backgroundColor: '#fff',
                     boxSizing: 'border-box',
           
                   }}
                 >
                <HeaderTwo />
                {/* Home > Job > Active Job */}
                <Breadcrumb parent='Home' title='Job' title1='Active Job' />
                <ActiveJob />

                <Footer/>

            </Box>
        </>
    )
}

export default ActiveJobPage;